module.exports = __webpack_public_path__ + "aa01b0b61afce203afdd1cc1b90937a2.woff2";